import styled from "styled-components";
import { colors, transition } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import TrayContainer from "../TrayContainer";

/* Full-screen tray used by OrderDetailsTray and the generic
 * ModalContainer molecule. Inset handling comes from TrayContainer;
 * the extra 40px on top + box-sizing: border-box keep the close X
 * clear of the inset and stop percentage-height children from
 * overflowing the visible region. The centring breakpoint turns the
 * tray into a 700×620 dialog (`maxWidth` narrows it) and overrides the
 * position: side trays
 * stay right-anchored until mdUp, but ModalContainer dialogs pass
 * `isDialog` to centre from smUp so they aren't pinned to the right
 * edge on tablet-width viewports. */
export default styled(TrayContainer)`
  box-sizing: border-box;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : colors.white)};
  transition: ${transition.baseTransition};
  height: 100%;
  width: 100%;
  max-width: ${(props) => props.maxWidth || 700}px;
  padding-top: calc(40px + env(safe-area-inset-top));
  padding-left: ${(props) => (props.sidePadding ? `${props.sidePadding}px` : "15px")};
  padding-right: ${(props) => (props.sidePadding ? `${props.sidePadding}px` : "15px")};
  z-index: 2200;
  overflow-y: ${(props) => (props.overflowY ? props.overflowY : "scroll")};
  -webkit-overflow-scrolling: touch;
  ${(props) => (props.isDialog ? breakpoints.smUp : breakpoints.mdUp)} {
    top: 50%;
    bottom: auto;
    max-height: calc(100vh - 40px);
    /* dvh cap (vh line above is the fallback) so the centred dialog
     * stays inside the visible viewport on tablets with browser UI. */
    max-height: calc(100dvh - 40px);
    height: ${(props) => (props.isMdUpHeightAuto ? "auto" : "620px")};
    right: 50%;
    padding: 60px 40px 40px;
    transform: translate(50%, -50%);
  }
`;
